import AgentBase from './AgentBase.vue';
import AgentLogin from './AgentLogin.vue';
import AgentDomainDetail from './AgentDomainDetail.vue';
import AgentDnsEditor from './AgentDnsEditor.vue';
import AgentHostingDetail from './AgentHostingDetail.vue';
import AgentTicketList from './AgentTicketList.vue';
import AgentTicketServiceList from './AgentTicketServiceList.vue';
import AgentTicketNew from './AgentTicketNew.vue';
import AgentTicketDetail from './AgentTicketDetail.vue';
import AgentDoctor from './AgentDoctor.vue';
import AgentDomainDoctor from './AgentDomainDoctor.vue';
import AgentSpTicketList from './AgentSpTicketList.vue';
import AgentSpTicketNew from './AgentSpTicketNew.vue';

export default {
  AgentBase,
  AgentLogin,
  AgentDomainDetail,
  AgentDnsEditor,
  AgentHostingDetail,
  AgentTicketList,
  AgentTicketServiceList,
  AgentTicketNew,
  AgentTicketDetail,
  AgentDoctor,
  AgentDomainDoctor,
  AgentSpTicketList,
  AgentSpTicketNew,
};
